module.exports = __webpack_public_path__ + "img/gantt.22d16d08.png";